export interface ExposeInterface {
    focusToBtnNextEpisode(): void;
    focusToBtnReplay(): void;
};

export enum ButtonsIds {
    btnReplay = "btn-replay",
    btnNextEpisode = "btn-next-episode",
  }

export interface ILabels {
    btnReplay: string;
    btnNextEpisode: string;
}
